import gql from 'graphql-tag';

export const queryForClaimsAndRoles = gql`
  query queryForClaimsAndRoles(
    $limit: Int
    $page: Int
    $query: RoleSortOrQuery
    $sort: RoleSortOrQuery
  ) {
    queryForClaimsAndRoles(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        name
        roles
      }
      totalRecords
    }
  }
`;
